import React from "react";
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { cloneArray, isDefined, sortReactTable } from '../../../utils';
import FreeTextQuestionIcon from '../../../icons/v3/FreeTextQuestionIcon';
import MultipleChoiceQuestionIcon from '../../../icons/v3/MultipleChoiceQuestionIcon';
import OpinionScaleQuestionIcon from '../../../icons/v3/OpinionScaleQuestionIcon';
import YesNotQuestionIcon from '../../../icons/v3/YesNotQuestionIcon';

class SelectQuestionType extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOptions: [],
            flag: false,
        };
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.selectOptions = this.selectOptions.bind(this);
        this.getOptionStyle = this.getOptionStyle.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        const
            {
                onClose
            } = this.props;

        if (this.wrapperRef) {
            if (!this.wrapperRef.current.contains(event.target)) {
                onClose(this.state.selectedOptions);
            }
        }
    }

    selectOptions(selectedId, selectedName) {
        const
            {
                onClose
            } = this.props;

        const selectedOption = { id: selectedId, value: selectedName }

        //deselecting
        if (this.state.selectedOptions.some(o => o.id === selectedId)) {
            this.state.selectedOptions = this.state.selectedOptions.filter(o => o.id !== selectedId);
        }
        else {
            this.state.selectedOptions[0] = selectedOption;
            let selectedOptionsArr = [selectedOption];
            onClose(selectedOptionsArr);
        }
    }

    getOptionStyle(optionId) {
        if (this.state.selectedOptions.some(o => o.id === optionId)) {
            const style =
            {
                border: '1px solid #C0EAED',
                boxShadow: '0px 1px 10px rgba(0, 0, 0, 0.15)',
                borderRadius: '8px'
            }
            return style;
        }
    }

    render() {
        const options = [
            {
                id: 1, name: 'Opinion Scale', icon: <OpinionScaleQuestionIcon />
            },
            {
                id: 2, name: 'Multiple Answer', icon: <MultipleChoiceQuestionIcon />
            },
            {
                id: 3, name: 'Yes/No', icon: <YesNotQuestionIcon />
            },
            {
                id: 4, name: 'Free Text', icon: <FreeTextQuestionIcon />
            }
        ];
        let result = {};
        result.columns = [
            {
                Header: 'a',
                accessor: 'nameIcon'
            },
        ];

        const loading = !(options && Array.isArray(options));
        if (loading === true) {
            return (<ReactTable className="SelectTable"
                columns={result.columns}
                defaultPageSize={10}
                loading={loading}
                className="-striped -highlight"
            />);
        }

        result.data = cloneArray(options);

        if (result.data && Array.isArray(result.data)) {
            result.data.forEach(row => {
                if (isDefined(row.name)) {
                    let selectedIcon;
                    if (this.state.selectedOptions.some(o => o.id === row.id)) {
                        selectedIcon = <CheckCircleIcon style={{ color: '#FF9538' }} />;
                    }

                    row.nameIcon = <div className="flex-container" style={{ textAlign: 'start' }}>
                        <div className="flex-container-start">
                            <div style={{ marginRight: '6px' }} >{row.icon}</div>
                            <div>{row.name}</div>
                        </div>

                        {selectedIcon}
                    </div>;
                }
            });
        }

        const questionTypesResultTable = (<ReactTable
            data={result.data}
            columns={result.columns}
            defaultPageSize={result.data.length}
            showPagination={false}
            loading={loading}
            className="-striped -highlight SelectTable"
            getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row) {
                    return {
                        onClick: () => this.selectOptions(rowInfo.original.id, rowInfo.original.name),
                        style: this.getOptionStyle(rowInfo.original.id)
                    };
                } else {
                    return {};
                }
            }}
            defaultSortMethod={sortReactTable}
        />);

        return <div ref={this.wrapperRef}>
            <div>
                <div className="select-pop-up-title" style={{ marginBottom: '10px' }}>Select Question Type</div>
            </div>
            <div>
                {questionTypesResultTable}
            </div>
        </div>;
    };
}

const select = state => ({});
export default connect(select)(SelectQuestionType);

